module.exports = __webpack_public_path__ + "static/assets/575d29ad857dc8716eb56ef5b0481a7b.svg";